import omniCountriesFollowing from './reducers';

import * as omniCountriesFollowingOperations from './operations';
import * as omniCountriesFollowingTypes from './types';
import * as omniCountriesFollowingAction from './actions';

export { omniCountriesFollowingOperations, omniCountriesFollowingTypes, omniCountriesFollowingAction };

export default omniCountriesFollowing;
